import Template from './components/template'
import React, { FormEvent, useState } from 'react'
import { useNavigate } from 'react-router'
import { user } from './lib/api'
import auth from './lib/auth'

export default function LoginPage() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const navigate = useNavigate()

    async function login(e: FormEvent) {
        e.preventDefault()
        setLoading(true)
        setError('')
        try {
            let token = await user.login(email, password)
            auth.setToken(token)
            navigate('/')
        } catch (e) {
            setError(String(e))
            setLoading(false)
        }
    }

    return (
        <Template>
            <div className='container mx-auto mt-5'>
                <h1>Log In</h1>

                <form onSubmit={login}>
                    <div className='font-bold text-gray-500'>Email</div>
                    <input type='text' value={email} onChange={(e) => setEmail(e.target.value)} />
                    <div className='font-bold text-gray-500'>Password</div>
                    <input
                        type='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className='my-2'>
                        <button className='blue' disabled={!email || !password || loading}>
                            Log In
                        </button>
                    </div>
                </form>
                {error && <p className='text-red-500'>{error}</p>}
            </div>
        </Template>
    )
}
